export async function authFetch(input: RequestInfo, init: RequestInit = {}) {
    const token = localStorage.getItem("token");

    const headers = new Headers(init.headers || {});
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    if (!headers.has("Content-Type")) {
        const method = (init.method || 'GET').toString().toUpperCase();
        if (init.body != null || (method !== 'GET' && method !== 'HEAD')) {
            headers.set("Content-Type", "application/json");
        }
    }

    return fetch(input, {
        ...init,
        headers,
    });
}